export const IconWithHover = {
  bindings: {
    icon: '<',
    hover: '<',
    placement: '<'
  },
  template: `<div class="hoverDiv" data-trigger="hover" data-auto-close="true"
                  data-placement="{{ $ctrl.placement ? $ctrl.placement : 'bottom' }}"
                  data-html="true" data-content="{{ $ctrl.hover }}" bs-popover ng-if="$ctrl.icon">
               <img ng-src="{{ $ctrl.icon }}">
             </div>`
};
